export default "__VITE_ASSET__BJ5qL1j8__"